import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import { LaunchPadContext } from './LaunchPad';
import Styled from './styles';

export interface LaunchPadTileProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. */
  children: React.ReactNode;
  /** To override the theme. Please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Place LaunchPad tile content here. */
const LaunchPadTile = React.forwardRef<HTMLElement, LaunchPadTileProps>((props: LaunchPadTileProps, ref) =>
  getContext(({ RTL, theme }) => {
    const { children, theme: themeProp, ...otherProps } = props;
    const { disableAnimation } = React.useContext(LaunchPadContext);
    const resolvedTheme = _merge({}, theme.LAUNCHPAD.TILE, themeProp);
    return (
      <Styled.LaunchPadTile
        $rtl={RTL}
        ref={ref}
        role="button"
        tabIndex="0"
        data-ccfk-launchpad-tile /** used for keyboard navigation */
        theme={resolvedTheme}
        elevationIndex={2}
        $disableAnimation={disableAnimation}
        {...otherProps}
      >
        {children}
      </Styled.LaunchPadTile>
    );
  }));

LaunchPadTile.displayName = 'LaunchPadTile';
LaunchPadTile.defaultProps = {
  theme: {}
};

/* Exports */
export { LaunchPadTile as default };
